import { useCallback, useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import CalculateMixesContent from "./components/calculateMixesContent";
import Disclaimer from "./components/disclaimer";
import CalculateByProductContent from "./components/calculateByProductContent";
import HeaderBanner from "./components/headerBanner";
import Footer from "./components/footer";
import { APIContext, APIType } from "./context/context";
import Cookies from "./components/cookies";
import { PRIVACY_POLICY_COOKIE_KEY } from "./constants/common";
import { date } from "yup";

export const queryClient = new QueryClient({
  // defaultOptions: {
  //   queries: {
  //     cacheTime: 86400000, // 24 * 60 * 60 * 1000 = one day
  //     staleTime: Infinity,
  //   },
  // },
  defaultOptions: {
    queries: {
      staleTime: Infinity,
    },
  },
});

function App() {

  const [APIText, setApiText] = useState<APIType | undefined>(undefined);

  useEffect(() => {
    getConfig();
    checkCookie();
  }, []);


  // cookies
  const [isShowPrivacyPolicyMessage, setIsShowPrivacyPolicyMessage] = useState(false);

  const getCookie = useCallback((cname: string) => {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }, []);

  const checkCookie = useCallback(() => {
    let privacy_policy_cookie = getCookie(PRIVACY_POLICY_COOKIE_KEY);
    if (privacy_policy_cookie === "") {
      setIsShowPrivacyPolicyMessage(true)
    }
  }, []);

  const handleSetIsShow = (isShow: boolean) => {
    setIsShowPrivacyPolicyMessage(isShow);
  }

  // END cookies


  async function getConfig() {
   // const ts = new Date().getTime();
   // const res = await fetch(`./config.json?ver=${ts}`);
    const res = await fetch('./config.json', {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
      },
    });
    const $APIText = await res.json();
    setApiText($APIText);
  }
  if (APIText === undefined) {
    return null;
  }
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename="/mortgageCalculator">
          {isShowPrivacyPolicyMessage && <Cookies setIsShow={handleSetIsShow} />}
          <div id="wrapper" className="m-5 rtl-grid ">
            <HeaderBanner />
            <APIContext.Provider value={APIText}>
              <Routes>
                <Route path="/" element={<Navigate to="Calc" />} />
                <Route path="Calc" element={<CalculateMixesContent />} />
                <Route path="ExtCalc" element={<CalculateByProductContent />} />
              </Routes>
              <Disclaimer />
              <Footer />
            </APIContext.Provider>
          </div>
        </BrowserRouter>
      </QueryClientProvider>
    </>
  );
}
export default App;